import UpdateIOUDocuments from "../UpdateIOUDocuments/UpdateIOUDocuments";

const ViewIOUDocuments = (props) => {
  return <UpdateIOUDocuments {...props} viewMode={true} />;
};

export default ViewIOUDocuments;
